import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Red marquee-style offers ticker shown right below the app Header.
 * Content is fetched from /api/offers-ticker; if disabled or empty, renders
 * nothing so the layout stays clean.
 */
export default function OffersTicker() {
  const [data, setData] = useState({ enabled: true, items: [] });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/offers-ticker");
        setData(data);
      } catch (e) {
        console.error("Failed to load offers ticker:", e);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  if (!loaded || !data.enabled || !data.items?.length) return null;

  // Duplicate the items so the CSS marquee has enough content for a seamless
  // loop regardless of how many offers the admin added.
  const rail = [...data.items, ...data.items];

  return (
    <div
      data-testid="offers-ticker"
      className="w-full text-white shadow-md"
      style={{ background: "linear-gradient(90deg,#c1121f 0%,#a30f18 100%)" }}
    >
      <div className="max-w-3xl mx-auto flex items-center gap-3 px-3 sm:px-4 py-2 overflow-hidden">
        <div className="hidden sm:flex items-center gap-1.5 font-black uppercase tracking-widest text-sm shrink-0">
          <Megaphone size={16} /> Offers
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div
            data-testid="offers-marquee"
            className="flex whitespace-nowrap animate-offers-marquee"
            style={{ animationDuration: `${Math.max(18, rail.length * 6)}s` }}
          >
            {rail.map((item, i) => (
              <span
                key={`${item.id}-${i}`}
                className="mx-6 text-sm font-semibold tracking-wide"
              >
                <span className="mr-2 text-yellow-200">★</span>
                {item.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
